import React, { ReactNode } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div
      className="modal-overlay"
      onMouseDown={onClose}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000
      }}
    >
      <div
        className="modal-content"
        onMouseDown={e => e.stopPropagation()}
        style={{
          background: '#fff', borderRadius: '10px', padding: '2em', minWidth: '350px', position: 'relative'
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;


